export enum LANGUAGE {
  KO = 'ko',
  EN = 'en',
}
export type LanguageType = (typeof LANGUAGE)[keyof typeof LANGUAGE];
export const LANGUAGE_LIST = Object.values(LANGUAGE) as LanguageType[];

// ko/en 모두 정식 지원·색인 대상. 두 로케일 모두 generateStaticParams 로 빌드되고
// sitemap.ts·각 페이지 hreflang(alternates.languages)에 ko/en/x-default 로 노출된다.
// → Google 이 두 언어판을 "중복/리디렉션 오류"가 아니라 서로의 대체 버전으로 인식한다.
export const SUPPORTED_LOCALES: readonly LanguageType[] = [
  LANGUAGE.KO,
  LANGUAGE.EN,
];
export type SupportedLocale = LanguageType;
export const isSupportedLocale = (lang: string): lang is SupportedLocale => {
  return SUPPORTED_LOCALES.includes(lang as LanguageType);
};
// 기본/대체(x-default) 로케일. 로케일 미확정 시 폴백이며 hreflang x-default 도 ko 를 가리킨다.
export const DEFAULT_LANGUAGE = LANGUAGE.EN;

// 로케일 영속화 쿠키. proxy(라우팅)·useLanguage(전환 UX)·SSR 이 공유하는 인프라이므로
// feature 가 아니라 shared 에 둔다.
export const LANGUAGE_COOKIE_KEY = 'language';
/** 언어 쿠키 유효 기간 (초). 1년 */
export const LANGUAGE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

// 헤더/세그먼트 등에서 들어온 임의 문자열을 지원 로케일로 확정한다.
// 미지원이거나 비어 있으면 기본 로케일로 폴백. (locale 분기 단일 출처)
export const resolveLocale = (lang?: string | null): SupportedLocale => {
  if (lang && isSupportedLocale(lang)) {
    return lang;
  }
  return DEFAULT_LANGUAGE;
};

// proxy 가 확정한 locale 을 루트 레이아웃으로 넘기는 request 헤더 키.
// (루트 레이아웃은 [locale] 세그먼트 param 에 접근할 수 없어 헤더로 전달)
export const LOCALE_HEADER = 'x-app-locale';

// proxy 가 요청 경로(로케일 포함)를 루트 레이아웃으로 넘기는 헤더 키.
// 루트 레이아웃은 [locale]/path param 에 접근할 수 없어 og:url 생성에 이 값을 쓴다.
export const PATHNAME_HEADER = 'x-app-pathname';

// 앱이 로드하는 메시지 네임스페이스. request.ts(런타임 로드)와
// locale-parity 테스트(키 정합성 가드)가 공유하는 단일 출처.
export const MESSAGE_NAMESPACES = [
  'common',
  'seo',
  'intro',
  'pricing',
  'onboarding',
  'detail',
  'bannerDetail',
  'editor',
  'meta',
  'error',
  'sider',
  'product',
  'videos',
  'productAssetPanel',
  'generateProductModal',
  'images',
  'bannerEditor',
  'banner',
  'canvas',
  'imageUpload',
  'banners',
  'details',
  'aiChat',
  'blog',
] as const;
